import React, { useEffect, useState } from 'react';
import '../style/css/topnav2026.css'
import IconTable from '../style/icons/menu.svg'
import IconDate from '../style/icons/calendar.svg'
import utils from "../services/utils";
import manageareas from "../services/manageareas";
import NotificationsBell from "../comps/NotificationsBell";
import QuickReservation from "../comps/QuickReservation";

const TopNavbar = ({ setAreaLock, isWorker }) => {
    const [structuredAreas, setStructureAreas] = useState([]);
    const [quickOpen, setQuickOpen] = useState(false); // global "הזמנת שולחן" modal
    const [areasLoading, setAreasLoading] = useState(true)

    const today = new Date();
    const weekday = today.toLocaleDateString('he-IL', { weekday: 'long' });
    const dateStr = today.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: '2-digit' });

    useEffect(() => {
        if (isWorker) fetchAreas()
    }, []);

    const fetchAreas = async () => {
        try {
            const areasData = await manageareas.getAllArea(true);
            // Check if deptsData is truthy and ensure it's an array
            if (areasData) {
                let areasArray;
                if (Array.isArray(areasData)) {
                    areasArray = areasData;
                } else if (typeof areasData === 'object' && areasData !== null) {
                    areasArray = [areasData];
                } else {
                    areasArray = []; // Set a default value to avoid breaking the application
                }
                let areasNew = processAreas(areasArray)
                if (areasNew) setStructureAreas(areasNew)
            }
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setAreasLoading(false);
        }
    };

    const processAreas = (areas) => {
        const areaMap = {};
        const nameToIdMap = {};
        const result = [];

        // First pass: Index areas
        areas.forEach(area => {
            // Normalize ID access (DB uses id, code used ID)
            const id = area.id || area.ID;
            if (id) {
                areaMap[id] = { ...area, id: id, subAreas: [] };
                if (area.name) nameToIdMap[area.name] = id;
            }
        });

        // Second pass: Build Hierarchy
        Object.values(areaMap).forEach(area => {
            const subTo = area.subToID;

            // Determine parent ID
            let parentId = null;
            if (subTo && subTo !== 0 && subTo !== "0") {
                // Check if subTo is an ID
                if (areaMap[subTo]) {
                    parentId = subTo;
                }
                // Check if subTo is a Name
                else if (nameToIdMap[subTo]) {
                    parentId = nameToIdMap[subTo];
                }
            }

            if (parentId) {
                // Is Sub Area
                areaMap[parentId].subAreas.push(area);
            } else {
                // Is Main Area (or orphan/failed parent lookup)
                result.push(area);
            }
        });

        return result;
    };

    const renderOptions = (areas, prefix = '') => {
        return areas.map(area => (
            <React.Fragment key={area.id}>
                <option value={area.id}>
                    {/* Indent visually if prefix exists, or use the prefix logic */}
                    {prefix}{area.name} {(!prefix && area.subAreas.length > 0) ? ` - ${utils.useLang('ALL')}` : ''}
                </option>
                {renderOptions(area.subAreas, `${area.name} - `)}
            </React.Fragment>
        ));
    };

    const handleAreaChange = (e) => {
        setAreaLock(e.target.value)
    }

    return (
        <>
            <header className="topbar">
                <div className="topbar-date">
                    <img className="topbar-date-icon" src={IconDate} alt="" aria-hidden="true" />
                    <div className="topbar-date-text">
                        <span className="topbar-weekday">{weekday}</span>
                        <span className="topbar-datenum" dir="ltr">{dateStr}</span>
                    </div>
                </div>

                {isWorker && (
                    <select className="topbar-area" onChange={handleAreaChange} disabled={areasLoading}>
                        <option value={0}>{areasLoading ? 'טוען אזורים…' : utils.useLang('ALL')}</option>
                        {renderOptions(structuredAreas)}
                    </select>
                )}

                <div className="topbar-actions">
                    <NotificationsBell />
                    {/* GLOBAL "הזמנת שולחן" — available on every page. */}
                    <button className="topbar-book" onClick={() => setQuickOpen(true)} aria-label="הזמנת שולחן">
                        <img src={IconTable} alt="" /><span className="topbar-book-lbl">הזמנת שולחן</span>
                    </button>
                </div>
            </header>
            {quickOpen && <QuickReservation onClose={() => setQuickOpen(false)} />}
        </>
    );
};

export default TopNavbar;